import { datadogRum } from '@datadog/browser-rum';
import { QUERIES_KEYS, QUERY_STALE_TIME } from 'constant';
import { APP_CONSTANTS } from 'constants/app';
import queryClient from 'remote-state/queryClient';
import { getFlagValue } from 'services/featureFlagsService';

export const featureFlagGuard = async (flagKey: string, defaultValue = false): Promise<boolean> => {
  const accountId = localStorage.getItem(APP_CONSTANTS.ACCOUNT_ID_LOCAL_KEY);

  if (!accountId) {
    return defaultValue;
  }

  try {
    const isEnabled = await queryClient.ensureQueryData({
      queryKey: [QUERIES_KEYS.FEATURE_FLAG, { accountId, flagKey }],
      queryFn: () => getFlagValue({ flagKey, accountId, defaultValue }).catch(() => defaultValue),
      staleTime: QUERY_STALE_TIME.MEDIUM,
    });

    return isEnabled;
  } catch (error) {
    const errorInstance = error instanceof Error ? error : new Error(String(error));
    datadogRum.addError(errorInstance, {
      info: `Unexpected error caught during feature flag (${flagKey}) check`,
    });
    return defaultValue;
  }
};
